

















































































/* eslint-disable camelcase, import/prefer-default-export */
/* eslint-disable camelcase */
/* eslint-disable no-restricted-syntax */
import { Component, Vue, Prop } from 'vue-property-decorator';
import INFO from '@/modules/FPKG-20000-Util/library/API/GetBranch';
import localesData from './locale.json';

interface locale {
  label?: string;
  value?: string;
  flag?: string;
  p12_ron_code: string;
  p12_ron_currency: string;
  p12_ron_id?: number;
  p12_ron_name: string;
  p12_ron_status: string;
  p12_ron_timezone: string;
}

@Component
export default class localeChanger extends Vue {
  private locales: any = [];

  private dialog: boolean = false;

  private currentLocale: locale = {
    p12_ron_code: '',
    p12_ron_currency: '',
    p12_ron_name: '',
    p12_ron_timezone: '',
    p12_ron_status: '',
  };

  public flagClass(flag: string) {
    const that = this;
    switch (flag) {
      case 'zh_TW':
        return 'tw';
      case 'zh_CN':
        return 'cn';
      case 'US':
        return 'us';
      case 'JP':
        return 'jp';
      case 'VN':
        return 'vn';
      case 'TH':
        return 'th';
      case 'KH':
        return 'kh';
      case 'MY':
        return 'my';
      case 'PH':
        return 'ph';
      default:
        return '';
    }
  }

  /**
   * created 接收bus訊號，並改變自身的dialog顯示狀態
   */
  public async created() {
    // 再拿布蘭奇站台
    this.getBranch();
    const regionBranch = JSON.parse(
      localStorage.getItem('regionBranch') || '{}',
    );
    if (regionBranch) {
      for (const region of regionBranch) {
        for (const locales of localesData) {
          if (region.p12_ron_code === locales.value) {
            region.flag = locales.flag;
          }
        }
      }
    }
    this.locales = regionBranch;
    this.$bus.$on('locale', (status: boolean) => {
      this.dialog = status;
    });
  }

  /**
   * setLocale 顯示目前的地區設定
   */
  public setLocale(locale: string | null) {
    if (locale) {
      [this.currentLocale] = this.locales.filter(
        (obj: any) => obj.p12_ron_code === locale,
      );
    }
  }

  public async getBranch() {
    const res: any = await this.$http.get('entertainmentBranch/common/getBranch');
    const adapter = res.data.response.region_adapter;
    const temp :any = [];
    for (const item of adapter) {
      // 如果有support_branch 在執行
      if (item.support_branch) {
        for (const support of item.support_branch) {
          temp.push(support);
        }
      }
    }

    // 尋找當前地區的id
    const regionId = res.data.response.region_list.find(
      (r: any) => r.p12_ron_code === res.data.response.region,
    );

    // 尋找 support_branch整理出來的資料 裡面是否包含當前地區 如果沒有再切換第區
    const findTemp = temp.find((r: any) => r === regionId.p12_ron_id);

    if (findTemp === undefined) {
      await this.$http.put('region/cutover/doModify', {
        p12_ron_id: temp[0],
      });
      // 找到後第一個code也要存儲
      const code = res.data.response.region_list.find((r: any) => r.p12_ron_id === temp[0]);
      localStorage.setItem('locale', code.p12_ron_code);
      window.location.reload();
    }

    const regionBranch: any = temp.map((d: number) => {
      // eslint-disable-next-line arrow-body-style
      const region = res.data.response.region_list.find((r: any) => {
        // eslint-disable-next-line no-unused-expressions
        return r.p12_ron_id === d;
      });
      return region;
    });
    localStorage.setItem('regionBranch', JSON.stringify(regionBranch));
    this.setLocale(localStorage.getItem('locale'));
  }

  public async change(country: locale) {
    if (country) {
      await this.$http.put('region/cutover/doModify', {
        p12_ron_id: country.p12_ron_id,
      });
      localStorage.setItem('locale', country.p12_ron_code);
      this.setLocale(country.p12_ron_code);
      // 再拿一次站台表 因為要眾拿地區
      await this.getBranch();
      window.location.reload();
    }
  }
}
